import { MAT_DATE_LOCALE } from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import {
  LocationStrategy,
  HashLocationStrategy,
  DatePipe,
} from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./auth/auth.guard";
import { AuthService } from "./auth/auth.service";
import { AppMaterialModule } from "./app_material/app-material.module";
import { HeaderComponent } from "./header/header.component";
import { DashboardComponent } from "./dashboard/dashboard.component";

import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgIdleModule } from '@ng-idle/core';

import { TokenInterceptor } from "../app/services/token.interceptor";
import { SortPipe } from "../app/utilities/sort-pipe";

import { PassGuardService } from "../app/auth/pass-guard.service";
import { AdminGuardService } from "../app/auth/admin-guard.service";
import { MHProffGuardService } from "../app/auth/mhProff-guard.service";

import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { ChartsModule } from "ng2-charts";

import { DistDashboardComponent } from "./dist-dashboard/dist-dashboard.component";

import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatButtonModule } from "@angular/material/button";

import { DistPatDataOverviewComponent } from "./dist-pat-data-overview/dist-pat-data-overview.component";
import { AddPatientsComponent } from './add-patients/add-patients.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    DashboardComponent,

    SortPipe,

    AdminDashboardComponent,

    DistDashboardComponent,

    DistPatDataOverviewComponent,

   

    AddPatientsComponent,
  ],
  imports: [
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AppRoutingModule,
    RouterModule,
    AppMaterialModule,
    ChartsModule,
    MatPaginatorModule,
    MatTableModule,
    MatButtonModule,
     NgIdleModule.forRoot(),
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    AuthGuard,
    AuthService,
    DatePipe,
    NgxSpinnerService,
    NgxSpinnerModule,
    PassGuardService,
    MHProffGuardService,
    AdminGuardService,
    
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
